var _rect, _rect2, _circle, _circle2, _circle3, _circle4, _rect3, _path, _rect4, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle5, _circle6, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle7, _circle8, _path27, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackgroundPattern = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1913,
    height: 1728,
    viewBox: "0 0 1913 1728",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32493_75354",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1913,
    height: 1728
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1913,
    height: 1728,
    fill: "#F2FAFB"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32493_75354)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -114,
    y: -120,
    width: 2239,
    height: 2350,
    fill: "#FCFEFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1104.5,
    cy: -220.5,
    r: 447.5,
    fill: "#F5F9FB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_32493_75354)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: -466,
    width: 1352,
    height: 661,
    rx: 330.5,
    stroke: "#F5F9FB",
    strokeWidth: 200,
    style: {
      mixBlendMode: "multiply"
    },
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -164,
    y: 529,
    width: 379,
    height: 379,
    rx: 189.5,
    stroke: "#F5F9FB",
    strokeWidth: 200,
    style: {
      mixBlendMode: "multiply"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1367.5,
    cy: 766.5,
    r: 429.5,
    fill: "#F2F8FB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.5,
    cy: 434.5,
    r: 482.5,
    fill: "#FCFEFF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: -630,
    width: 574,
    height: 592,
    rx: 287,
    stroke: "#F5F9FB",
    strokeWidth: 200,
    style: {
      mixBlendMode: "multiply"
    }
  }), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 343,
    cy: 701,
    r: 234,
    fill: "#FBFEFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_32493_75354",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 527,
    width: 796,
    height: 985
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 527,
    width: 796,
    height: 985,
    fill: "#E8F2F7"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_32493_75354)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_32493_75354)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 707,
    y: 745,
    width: 929,
    height: 509,
    rx: 254.5,
    stroke: "#EAF4FA",
    strokeWidth: 200,
    style: {
      mixBlendMode: "multiply"
    },
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1082.5 669.5C1082.5 727.214 984 811.5 961 845.5C903.286 845.5 845.777 851.206 803 796.5C770.94 755.5 775.5 696.5 775.5 696.5C819 609 1082.5 611.786 1082.5 669.5Z",
    fill: "#FCFEFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_32493_75354",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 853,
    y: 285,
    width: 595,
    height: 293
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.71,
    y: 285,
    width: 292.5,
    height: 594.712,
    transform: "rotate(90 1447.71 285)",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_32493_75354)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1119.79,
    cy: 563.789,
    r: 179.385,
    transform: "rotate(90 1119.79 563.789)",
    fill: "#F4FAFD",
    style: {
      mixBlendMode: "darken"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_32493_75354)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1303,
    cy: 853,
    r: 109,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1337.61 446.431C1334.58 445.618 1332.78 442.487 1333.59 439.436C1334.41 436.385 1337.54 434.575 1340.57 435.388C1343.61 436.201 1345.41 439.332 1344.59 442.383C1343.77 445.434 1340.65 447.244 1337.61 446.431Z",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1352.43 517.975C1349.39 517.161 1347.59 514.031 1348.41 510.98C1349.22 507.928 1352.35 506.118 1355.38 506.931C1358.42 507.745 1360.22 510.875 1359.4 513.927C1358.59 516.978 1355.46 518.788 1352.43 517.975Z",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.21 476.943C1357.18 476.129 1355.38 472.999 1356.19 469.947C1357.01 466.896 1360.14 465.086 1363.17 465.899C1366.21 466.713 1368.01 469.843 1367.19 472.894C1366.38 475.946 1363.25 477.756 1360.21 476.943Z",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1336.07 446.213L1314.12 485.06",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1349 509.209L1314.04 485.36",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1356.5 473.482C1342.5 477.982 1272 502.982 1182 496.482",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M580.116 453.488C580.929 456.523 579.119 459.649 576.068 460.467C573.017 461.284 569.886 459.482 569.073 456.447C568.26 453.411 570.07 450.286 573.121 449.468C576.172 448.651 579.303 450.452 580.116 453.488Z",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M634.668 404.888C635.482 407.924 633.672 411.049 630.62 411.867C627.569 412.684 624.439 410.883 623.625 407.847C622.812 404.812 624.622 401.686 627.673 400.868C630.724 400.051 633.855 401.853 634.668 404.888Z",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M595.239 418.659C596.053 421.695 594.243 424.821 591.191 425.638C588.14 426.456 585.01 424.654 584.196 421.619C583.383 418.583 585.193 415.457 588.244 414.64C591.296 413.822 594.426 415.624 595.239 418.659Z",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M580.699 454.934L625.316 454.52",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M628.788 412.234L625.617 454.439",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M594.1 423.607C604.997 433.481 661.898 482.036 701.269 563.228",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.17 928.495C1231.47 940.35 1189.03 1001.95 1112.33 1049.47",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1244.45,
    cy: 923.119,
    r: 6.55707,
    transform: "rotate(84.5061 1244.45 923.119)",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1262.02,
    cy: 884.562,
    r: 6.55707,
    transform: "rotate(84.5061 1262.02 884.562)",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M526.519 51.4998C527.198 54.0335 525.687 56.643 523.14 57.3256C520.592 58.0082 517.979 56.5037 517.3 53.9701C516.621 51.4365 518.132 48.827 520.679 48.1444C523.227 47.4618 525.84 48.9662 526.519 51.4998Z",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M572.785 10.282C573.464 12.8156 571.953 15.4251 569.405 16.1077C566.858 16.7903 564.245 15.2859 563.566 12.7523C562.887 10.2187 564.398 7.60919 566.945 6.92659C569.493 6.24399 572.106 7.74843 572.785 10.282Z",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M539.345 22.8099C540.024 25.3435 538.513 27.953 535.965 28.6356C533.418 29.3182 530.805 27.8138 530.126 25.2802C529.447 22.7466 530.958 20.1371 533.505 19.4545C536.053 18.7719 538.666 20.2763 539.345 22.8099Z",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M527.087 52.7083L564.927 52.3571",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M567.871 16.4939L565.181 52.2885",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M538.876 27.0994C546.509 33.8842 574.92 59.3275 593.579 86.043",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44886 693.225C6.21681 694.305 3.52525 693.366 2.4389 691.121C1.35256 688.877 2.28558 686.183 4.51763 685.103C6.74967 684.022 9.44123 684.962 10.5276 687.206C11.6139 689.451 10.6809 692.145 8.44886 693.225Z",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1952 729.063C52.9632 730.144 50.2716 729.204 49.1852 726.96C48.0989 724.715 49.0319 722.021 51.264 720.941C53.496 719.861 56.1876 720.8 57.2739 723.045C58.3603 725.289 57.4272 727.983 55.1952 729.063Z",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5265 700.078C35.2945 701.158 32.6029 700.219 31.5165 697.974C30.4302 695.73 31.3632 693.036 33.5953 691.955C35.8273 690.875 38.5189 691.815 39.6052 694.059C40.6916 696.304 39.7585 698.997 37.5265 700.078Z",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43237 693.993L14.5174 729.262",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5285 725.607L14.6269 729.487",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4484 700.428C28.4764 708.766 9.79362 739.837 -11.8187 762.029",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 934.806,
    cy: 34.3466,
    r: 5.22562,
    transform: "rotate(-69.1929 934.806 34.3466)",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 908.173,
    cy: 56.077,
    r: 5.22562,
    transform: "rotate(-69.1929 908.173 56.077)",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M938.734 31.353C947.218 26.5085 978.968 8.53393 1008.89 -0.210787",
    stroke: "#9FBAC6",
    strokeOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 577,
    y: 78.96,
    width: 22,
    height: 18,
    transform: "rotate(-39.3874 577 78.96)",
    fill: "#FCFEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_32493_75354",
    x: 355,
    y: -566,
    width: 1610,
    height: 919,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 50,
    dy: 50
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.833299 0 0 0 0 0.930383 0 0 0 0 0.970833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32493_75354"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32493_75354",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_32493_75354",
    x: 607,
    y: 644,
    width: 1313,
    height: 875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 101,
    dy: 82
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.695911 0 0 0 0 0.773307 0 0 0 0 0.805556 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32493_75354"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32493_75354",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_32493_75354",
    x: 1194,
    y: 744,
    width: 268,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 30,
    dy: 30
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.815686 0 0 0 0 0.890196 0 0 0 0 0.921569 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32493_75354"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32493_75354",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackgroundPattern);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/background-pattern.da565a7d1feb8dbc0394ce41345d2358.svg";